import { formatCurrency, formatDecimal, formatUnit } from "@/common/utils/formatters";
import { BranchesEquipmentsConsumptionsTotalizerData, ParsedBranchesEquipmentsConsumptionsTotalizerData } from "../types/branchesEquipmentsConsumptionsTotalizer.type";
import { unities } from "@/common/constants/unities.constants";

export class BranchesEquipmentsConsumptionsTotalizerTransformer {

  static totalizerTransformer() {
    return (branchesEquipmentsConsumptionsTotalizer: BranchesEquipmentsConsumptionsTotalizerData[]) => {
      return branchesEquipmentsConsumptionsTotalizer.reduce((prev, curr, index) => {
        const branchId = curr.branch_id;

        let branch = prev.find(({ id }) => id === branchId);

        if (!branch) {
          branch = {
            id: curr.branch_id,
            displayName: curr.branch_display_name,
            totalAmount: curr.branch_total_amount ? formatCurrency(Number(curr.branch_total_amount)) : '--',
            equipmentsCount: curr.branch_equipments_count,
            equipments: [],
            branchesTotalAmount: index === 0 && curr.branch_total_amount
              ? formatCurrency(Number(curr.branches_total_amount))
              : undefined,
          }

          prev.push(branch);
        }

        let equipment = branch.equipments.find(({ identifier }) => identifier === curr.equipment_identifier);

        if (!equipment) {
          equipment = {
            identifier: curr.equipment_identifier,
            fieldForDisplay: curr.equipment_field_for_display,
            categoryDisplayName: curr.equipment_category_display_name,
            modelDisplayName: curr.equipment_model_display_name,
            modelBrand: curr.equipment_model_brand,
            modelYear: `${curr.equipment_model_year}`,
            status: curr.equipment_status,
            totalAmount: curr.equipment_total_amount ? formatCurrency(Number(curr.equipment_total_amount)) : '--',
            products: [],
          }

          branch.equipments.push(equipment);
        }

        equipment.products.push({
          displayName: curr.product_display_name,
          unitForQuantity: curr.unit_for_quantity,
          unitForQuantityAbreviation: curr.unit_for_quantity_abreviation,
          consumedTotal: curr.consumed_total ? formatCurrency(Number(curr.consumed_total)) : '--',
          totalQuantity: curr.total_quantity
            ? formatUnit(formatDecimal(curr.total_quantity, 4, 2), curr.unit_for_quantity_abreviation)
            : '--',
          averageUnitPrice: curr.average_unit_price ? formatCurrency(Number(curr.average_unit_price)) : '--',
          averageQuantity: curr.average_quantity
            ? formatUnit(formatDecimal(curr.average_quantity, 4, 2), curr.unit_for_quantity_abreviation)
            : '--',
          averageUsage: curr.average_usage ? formatUnit(Number(curr.average_usage), 'kilometers') : '--',
          totalUsage: curr.total_usage ? formatUnit(formatDecimal(curr.total_usage, 0), 'kilometers') : '--',
          averageConsumptionQuantityPerUsageQuantityPerUsage: curr.average_consumption_quantity_per_usage_quantity_per_usage
            ? formatUnit(
              formatDecimal(curr.average_consumption_quantity_per_usage_quantity_per_usage, 4, 2),
              `${unities['kilometers']}/${curr.unit_for_quantity_abreviation}`
            )
            : '--'
        });

        return prev;
      }, [] as ParsedBranchesEquipmentsConsumptionsTotalizerData[]);
    }
  }

}
